module.exports = require('./helpers/bundle-url').getBundleURL('UT8wI') + "logo.7718c6df.svg";